import { Payee401kRateDetails } from "../../Payee401kRateDetails";
import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOffice401kSlideout extends Layout {
    checkboxOnHold: Checkbox;
    layoutPayRateDetail: Payee401kRateDetails;
    sourceDetail401kRate: DataSource;
    sourcePayee401kRate: DataSource;
    textboxCalculationMethod: Textbox;
    textboxContribType: Textbox;
    textboxDeductCodeId: Textbox;
    textboxEffectiveDate: Textbox;
    textboxExpireDate: Textbox;
}
